export const RECORD_ID_QUERY_PARAM = 'recordId';